import { useState } from 'react';
import { changeFeedbackModalState } from '../../store/actionCreators';
import { useDispatch } from 'react-redux';
import burgerIcon from '../../../images/burger-icon.svg';
import OutsideAlerter from '../../hooks/OutsideAlerter';
import * as Styled from './BurgerMenuStyles'
import {InviteModal} from '../InviteModal/InviteModal';

const BurgerMenu = () => {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [inviteOpen, setInviteOpen] = useState(false);
  const dispatch = useDispatch();

  const openInviteModal = () => {
    setInviteOpen(true);
  }
  const closeInviteModal = () => {
    setInviteOpen(false);
  }

  return (
    <>
      <OutsideAlerter setFunction={setMenuVisible} >
        <Styled.BurgerMenuWrapper>
          <Styled.StyledImg
            src={burgerIcon}
            alt="Burger icon menu"
            onClick={() => setMenuVisible(currValue => !currValue)}
          />
          <Styled.Menu>
            {
              isMenuVisible ?
                <Styled.StyledList>
                  <Styled.StyledListItem>
                    <Styled.CustomLink
                      to='/searchportal'
                      className="d-lg-none"
                      onClick={() => setMenuVisible(false)}
                    >
                      Go to Search
                    </Styled.CustomLink>
                  </Styled.StyledListItem>
                  <Styled.StyledListItem>
                    <Styled.CustomLink to='/account' onClick={() => setMenuVisible(false)}>
                      Accounts
                    </Styled.CustomLink>
                  </Styled.StyledListItem>
                  <Styled.StyledListItem>
                    <Styled.CustomLink to='/youractivity'
                                       onClick={() => setMenuVisible(false)}
                    >
                      Your Activity
                    </Styled.CustomLink>
                  </Styled.StyledListItem>
                  <Styled.StyledListItem>
                    <Styled.CustomLink to='/how-it-works'
                                       onClick={() => setMenuVisible(false)}
                    >
                      How Trova Works
                    </Styled.CustomLink>
                  </Styled.StyledListItem>
                  <Styled.StyledListItem>
                    <Styled.SpanClicable onClick={openInviteModal}>
                      Invite Friends
                    </Styled.SpanClicable>
                  </Styled.StyledListItem>
                  <Styled.StyledListItem>
                    <Styled.SpanClicable onClick={() => {
                      dispatch(changeFeedbackModalState())
                      setMenuVisible(false)
                    }}>
                      Feedback
                    </Styled.SpanClicable>
                  </Styled.StyledListItem>
                </Styled.StyledList>
                :
                null
            }
          </Styled.Menu>
        </Styled.BurgerMenuWrapper>
      </OutsideAlerter>
      <InviteModal
        isOpen={inviteOpen}
        onClose={closeInviteModal}
      />
    </>
  );
}

export default BurgerMenu;